import { z } from 'zod';
import { documentExtensionSchema } from '../documents/document.schemas.js';

export const publicationPendingSubmitDtoSchema = z.object({
  submitId: z.string().uuid(),
  documentId: z.string().uuid(),
  documentName: z.string(),
  extension: documentExtensionSchema,
  submittedAt: z.string().datetime(),
  submittedByAlias: z.string(),
  /** Nombre de lignes de valeur encore en attente de décision validateur. */
  pendingValidationCount: z.number().int().nonnegative(),
});

export const publicationPublishedDocumentDtoSchema = z.object({
  publishId: z.string().uuid(),
  documentId: z.string().uuid(),
  documentName: z.string(),
  extension: documentExtensionSchema,
  publishName: z.string(),
  version: z.number().int(),
  publishedAt: z.string().datetime(),
});

/** Dernière soumission du document : toutes les décisions sont prises, au moins un refus. */
export const publicationRejectedSubmitDtoSchema = z.object({
  submitId: z.string().uuid(),
  documentId: z.string().uuid(),
  documentName: z.string(),
  extension: documentExtensionSchema,
  submittedAt: z.string().datetime(),
  submittedByAlias: z.string(),
  rejectedValidationCount: z.number().int().nonnegative(),
});

export type PublicationPendingSubmitDto = z.infer<typeof publicationPendingSubmitDtoSchema>;
export type PublicationPublishedDocumentDto = z.infer<typeof publicationPublishedDocumentDtoSchema>;
export type PublicationRejectedSubmitDto = z.infer<typeof publicationRejectedSubmitDtoSchema>;
